import { gql, useMutation } from '@apollo/client';
import { Obj } from '@livecontrol/core-utils';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { Errors } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

const MUTATION = gql`
mutation FinishAssetReplace($clientId: Int!, $assetId: Int!, $archiveVideoUrl: String!, $duration: Float) {
  FinishAssetReplace(client_id: $clientId, asset_id: $assetId, archive_video_url: $archiveVideoUrl, duration: $duration) {
    id
    archive_thumbnail_url
    archive_video_url
  }
}
`;

interface TVariables {
    clientId: number;
    assetId: number;
    archiveVideoUrl: string;
    duration?: number;
}

interface TData {
    FinishAssetReplace: {
        id: number;
        archive_thumbnail_url: string;
        archive_video_url: string;
    };
}

type Args = Partial<TVariables>;
type AssetReplace = TData['FinishAssetReplace'];

export const useFinishAsset = (): [
    (args: Args) => Promise<AssetReplace | undefined>,
    MutationResult<AssetReplace>
] => {
    const [mutation, { loading, called, data }] = useMutation<TData, TVariables>(MUTATION);

    return [
        useCallback(async (args: Args) => {
            let data_: AssetReplace | undefined;

            try {

                const toEvaluate = {
                    clientId: args.clientId,
                    assetId: args.assetId,
                    archiveVideoUrl: args.archiveVideoUrl,
                }
                if (!Obj.isHydrated(toEvaluate)) {
                    throw Errors.badRequest();
                }

                const response = await mutation({ variables: {...toEvaluate, duration:args.duration} });

                data_ = response.data?.FinishAssetReplace;
            } catch {
                //
            }

            return data_;
        }, [mutation]),
        {
            loading,
            called,
            data: data?.FinishAssetReplace
        }
    ];
};
